import { Component, ElementRef, EventEmitter, Input, OnInit, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MatAccordion } from '@angular/material/expansion';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { toasterMessages } from '@messages/*';
import * as ace from "ace-builds";
import { ToastrService } from 'ngx-toastr';
import { configureAceSession } from 'src/app/shared/ace-mode-utils';

@Component({
  selector: 'app-selected-cqs-list',
  templateUrl: './selected-cqs-list.component.html',
  styleUrls: ['./selected-cqs-list.component.scss']
})

export class SelectedCqsListComponent implements OnInit {
  @ViewChildren("selectedQPrevCodeEditor") private selectedQPrevCodeEditor: QueryList<ElementRef>;

  @Input() selectedCodingQuestions = [];
  @Input() title: string = '';
  @Input() from: string = '';
  @Input() hasAction: boolean = true;
  @Output() removeCodingQuestion = new EventEmitter<string>();
  @ViewChild(MatAccordion) accordion: MatAccordion;
  selectedLang: number = 0;
  testCaseResults = {
    success: 0,
    failure: 0,
    errored: 0
  };
  seletedPreviewCodeAceEditor: any;
  snackcontent: string = '';
  private clerSnackbartime;
  config: AngularEditorConfig = {
    height: 'auto',
    minHeight: '0',
    width: 'auto',
    minWidth: '0',
    showToolbar: false
  };

  constructor(private toastr: ToastrService) { }

  /**
   * Convert escaped newlines (\n as text) to actual newlines
   */
  private convertEscapedNewlines(code: string): string {
    if (!code) return '';
    return code.replace(/\\n/g, '\n');
  }

  ngOnInit(): void { }

  removeCq(question): void {
    if (this.hasAction) {
      this.removeCodingQuestion.emit(question);
    } else {
      this.toastr.warning(toasterMessages.assessmentEditWarning, '');
    }
  }

  toggleLangSelect(cq, lang): void {
    lang.isUnlinkedFromAssessment = !lang.isUnlinkedFromAssessment;
    let activeLangCount = cq.questionSignatures?.filter(n => !n.isUnlinkedFromAssessment)?.length;
    if (!activeLangCount) {
      lang.isUnlinkedFromAssessment = !lang.isUnlinkedFromAssessment
      this.snackcontent = toasterMessages.snackbar.atLeastOneLangWarning;
    } else if (!lang.isUnlinkedFromAssessment) {
      this.snackcontent = toasterMessages.snackbar.canSolveWithOtherLang.replace('{lang}', `${lang.functionSignature?.code_language}`);
    }
    if (this.clerSnackbartime) {
      clearInterval(this.clerSnackbartime);
    }
    this.clerSnackbartime = setTimeout(() => {
      this.snackcontent = '';
    }, 2000);

  }

  showFullQuestion(idx) {
    const editor: any = ace.edit(this.selectedQPrevCodeEditor.toArray()[idx].nativeElement);
    const height = editor.session.getScreenLength() * (editor.renderer.lineHeight || 14) + (editor.renderer.scrollBar?.getWidth?.() || editor.renderer.scrollBar?.width || 0);
    const element = document.getElementById('selected-ace-editor-' + idx + this.from);
    if (element) {
      element.style.height = height + 10 + 'px';
    }
    editor.resize();
  }

  opened(cq, cqIdx, langIdx = 0): void {
    this.selectedLang = langIdx;
    ace.config.set("fontSize", "14px");
    ace.config.set('basePath', 'https://unpkg.com/ace-builds@1.4.12/src-noconflict');
    const editor = ace.edit(this.selectedQPrevCodeEditor.toArray()[cqIdx].nativeElement);
    editor.session.setValue(this.convertEscapedNewlines(cq.questionSignatures[langIdx]?.functionSignature?.source_code));
    editor.setTheme('ace/theme/solarized_dark');
    editor.setReadOnly(true);

    this.testCaseResults = {
      success: cq.questionSignatures[langIdx]?.run_results.success,
      failure: cq.questionSignatures[langIdx]?.run_results.failure,
      errored: cq.questionSignatures[langIdx]?.run_results.errored,
    }
    configureAceSession(editor.session, cq.questionSignatures[langIdx]?.functionSignature?.code_language);
    this.showFullQuestion(cqIdx);
  }

}